<template>
  <div v-if="siteData">
    <b-container style="margin-top: 75px;">
      <hero-banner
          :img-banner-url="bannerImgURL"
          :img-logo-url="logoImgURL"
      />
      <b-row>
        <b-col cols="5" offset="4">
          <h4>
            {{organizationName}}
          </h4>
        </b-col>
        <b-col>
          <b-button
              class="float-right"
              rounded
              variant="light"
              style="margin-left: 15px"
          >
            Chat
          </b-button>
          <b-button
              class="float-right"
            rounded
            variant="primary"
          >
            Learn More
          </b-button>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col md="8">
          <b-tabs
              :pills="tabs.isPills"
              :small="tabs.isSmall"
              :justified="tabs.isJustified"
              :isFill="tabs.isFill"
              :end="tabs.isEnd"
              :vertical="tabs.isVertical"
              content-class="mt-3"
              defaultActiveKey="stage"
          >
            <b-tab
                v-for="(aSection, index) in availSections"
                :key="index"
                :title="aSection.title"
            >
              <template #title>
                <h6 style="padding-top: 25px;">
                  <b-icon
                      v-if="aSection.icon"
                      :icon="aSection.icon"
                      aria-hidden="true"
                  />
                  {{ aSection.title }}
                </h6>
              </template>
              <component
                  :ref="aSection.componentName"
                  style="margin-top: 35px;"
                  :is="aSection.component"
                  v-bind="propsData"
              />
            </b-tab>
          </b-tabs>
        </b-col>
        <b-col>
          <org-info
            :site-data="siteData"
            />
        </b-col>
      </b-row>
      <Form />
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RecordViews from "@/mixins/RecordViews";
import HeroBanner from "./heroBanner";
import OrgInfo from "./orgInfo";
import Intro from "./intro";
import About from "./about";
import FAQS from "./faqs";
import Sessions from "./sessions";
import Services from "./services";

export default {
  name: "Site_Provider",
  mixins: [RecordViews],
  components: {
    HeroBanner,
    OrgInfo
  },
  beforeMount() {
    this.profileName = this.$route.params.profileName;
  },
  mounted() {
    this.getSiteData();
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    bannerImgURL() {
      return this.siteData && this.siteData.info && this.siteData.info.imgBannerURL ?
          this.siteData.info.imgBannerURL : "/assets/providers/default.png";
    },
    logoImgURL() {
      return this.siteData && this.siteData.info && this.siteData.info.imgURL ?
          this.siteData.info.imgURL : "/assets/providers/default.png";
    },
    organizationName() {
      return this.siteData && this.siteData.info && this.siteData.info.name ?
          this.siteData.info.name : null;
    },
    orgDescription() {
      return this.siteData && this.siteData.info && this.siteData.info.descriptioo ?
          this.siteData.info.description : null;
    },
    address1() {
      return this.siteData && this.siteData.info && this.siteData.info.address1 ?
          this.siteData.info.address1 : null;
    },
    city() {
      return this.siteData && this.siteData.info && this.siteData.info.city ?
          this.siteData.info.city : null;
    },
    state() {
      return this.siteData && this.siteData.info && this.siteData.info.state ?
          this.siteData.info.state : null;
    },
    phone() {
      return this.siteData && this.siteData.info && this.siteData.info.phone ?
          this.siteData.info.phone : null;
    },
    email() {
      return this.siteData && this.siteData.email && this.siteData.info.email ?
          this.siteData.info.email : null;
    },
    zip() {
      return this.siteData && this.siteData.info && this.siteData.info.zip ?
          this.siteData.info.zip : null;
    },
    url() {
      return this.siteData && this.siteData.info && this.siteData.info.url ?
          this.siteData.info.url : null;
    },
    availSections() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    },
    propsData() {
      return {
        provider: this.siteData
      };
    }
  },
  methods: {
    handleNoCornerData() {
      this.$router.push("/");
    },
    getSiteData() {
      this.$store
        .dispatch("provider/getProviderData",
            {
              profileName: this.profileName
            }
        )
        .then(res => {
          debugger
          if (Object.keys(res).length === 0) {
            this.handleNoCornerData();
          } else {
            this.siteData = res;
            this.recordView(this.siteData.id);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    recordView(publishingId) {
      this.$store.dispatch("listings/recordFeedback", {
        userId: this.user ? this.user.uid : null,
        pathId: "publishings",
        entityId: publishingId,
        feedbackType: "views",
        sessionId: this.checkSession("sessions")
      });
    },
  },
  metaInfo() {
    return {
      title: "JourneyBinder Blog",
      meta: [
        // Twitter Card
        { name: "twitter:title", content: this.blogTitle },
        { name: "twitter:card", content: "Our Blog Page" },
        { name: "twitter:description", content: this.description },
        { name: "twitter:image", content: this.logo },
        { property: "og:title", content: this.blogTitle },
        { property: "og:site_name", content: "JourneyBinder" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        { property: "og:description", content: this.description }
      ]
    };
  },
  data() {
    return {
      siteData: null,
      tabs: {
        isPills: false,
        isSmall: true,
        isJustified: true,
        isFill: true,
        isEnd: false,
        isVertical: false
      },
      tab: {
        titleLinkAttributes: {
          color: "#5695e0"
        },
        hexColorTabBg: "#777",
        hexColorTabText: "#777",
        hexColorScreen: "#777"
      },
      sections: [
        {
          id: "intro",
          title: "Intro",
          component: Intro,
          componentName: "Intro",
          avail: true
        },
        {
          id: "about",
          title: "About",
          component: About,
          componentName: "About",
          avail: true
        },
        {
          id: "services",
          title: "Services",
          component: Services,
          componentName: "Services",
          avail: true
        },
        {
          id: "faqs",
          title: "FAQs",
          component: FAQS,
          componentName: "FAQS",
          avail: true
        },
        {
          id: "sessions",
          title: "Events",
          component: Sessions,
          componentName: "Sessions",
          avail: true
        }
      ],
    };
  },
};
</script>
